import { ColumnTypeEnum } from '~components/dynamic-table/models/enums/column-type.enum';
import { TextAlignmentEnum } from '~core/models/enums/text-alignment.enum';
import { BaseColumnModel } from './base-column.model';

export class StringColumnModel extends BaseColumnModel {
    suffixPropertyName?: string;
    textAlignment = TextAlignmentEnum.Left;
    shouldTruncateText = false;
    shouldShowTooltip = false;

    constructor(init?: Partial<StringColumnModel>) {
        super(ColumnTypeEnum.Text);

        if (!!init) {
            Object.assign(this, init);
        }
    }
}
